import type { BoardroomDeliverable } from '../../types';

/** KEEP THIS PAGE: an item you dug into could only be found again by its
 *  link. Keeping it makes it one of your VIEWS - the things the room can show,
 *  listed in All views - and pinning a view puts it on the Dashboard. Says where it
 *  is once it is kept. */
export default function KeepPage({
  card,
  onKeep,
}: {
  card: BoardroomDeliverable | undefined;
  onKeep: (pinned: boolean) => void;
}) {
  const btn =
    'rounded border border-gray-300 px-2 py-0.5 text-xs text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700';
  if (card?.pinned) {
    return (
      <span className="text-xs text-indigo-700 dark:text-indigo-300" data-testid="keep-page-state">
        On the Dashboard
      </span>
    );
  }
  if (card) {
    return (
      <span className="flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400" data-testid="keep-page-state">
        Kept with your views
        <button type="button" onClick={() => onKeep(true)} className={btn} data-testid="keep-page-pin">
          Pin to Dashboard
        </button>
      </span>
    );
  }
  return (
    <button
      type="button"
      onClick={() => onKeep(false)}
      className={btn}
      title="Keep this page with your views, so you can find it again in All views"
      data-testid="keep-page"
    >
      Keep with your views
    </button>
  );
}
